import { render, staticRenderFns } from "./BottomNav.vue?vue&type=template&id=75563ac9&scoped=true"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"
import style0 from "./BottomNav.vue?vue&type=style&index=0&id=75563ac9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75563ac9",
  null
  
)

export default component.exports